import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import { useAuth } from "../../context/AuthContext";
import "../../style/pages.css";
import "./Crops.css";

export default function Crops() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [query, setQuery] = useState("");
  const [level, setLevel] = useState("all");

  useEffect(() => { api.getCrops().then(setItems); }, []);

  const filtered = useMemo(() => items.filter((item) => {
    const matchesQuery = `${item.name} ${item.code} ${item.habitat}`.toLowerCase().includes(query.toLowerCase());
    const matchesLevel = level === "all" || item.level >= Number(level);
    return matchesQuery && matchesLevel;
  }), [items, query, level]);

  return (
    <div>
      <header className="page-head"><div><p className="eyebrow">THREAT ARCHIVE / CLEARANCE 02+</p><h1>크롭 데이터베이스</h1></div><div className="crop-head-actions"><p>정찰대와 생존자가 공유한 관측 기록입니다. 확인되지 않은 추정 정보가 포함될 수 있습니다.</p>{user?.clearance >= 3 && <Link className="primary-button crop-register-link" to="/crops/register">신규 크롭 등록</Link>}</div></header>
      <section className="crop-toolbar panel">
        <div className="field"><label htmlFor="crop-search">개체명·코드·지역 검색</label><input id="crop-search" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="예: 버터플라이, CRP-01" /></div>
        <div className="field"><label htmlFor="crop-level">최소 위험 등급</label><select id="crop-level" value={level} onChange={(e) => setLevel(e.target.value)}><option value="all">전체 등급</option><option value="4">4단계 이상</option><option value="6">6단계 이상</option></select></div>
        <div className="result-count"><strong>{filtered.length}</strong><span>기록 확인</span></div>
      </section>
      <section className="crop-list">
        {filtered.map((crop) => <Link to={`/crops/${crop.id}`} key={crop.id} className="crop-row panel"><div className="crop-id"><span className="level">L{crop.level}</span><code>{crop.code}</code></div><div className="crop-main"><div><h2>{crop.name}</h2><span className="status-tag">{crop.status}</span></div><p>{crop.description}</p><small>{crop.habitat} · 조우 {crop.encounterCount}회</small></div><div className="crop-last"><span>LAST SIGNAL</span><strong>{crop.lastSeen}</strong><b>기록 열람 →</b></div></Link>)}
        {!filtered.length && <div className="empty-state">조건에 일치하는 개체 기록이 없습니다.</div>}
      </section>
    </div>
  );
}
